export default "__VITE_ASSET__f9b0824a__"